import React from 'react'
import { useEffect, useState, useRef } from "react";
import { ChatState } from '../context/chatProvider';
import { Box, Stack, Text,Divider } from "@chakra-ui/layout";
import { getSender } from "../config/ChatLogistics"

 const toggleScroll = (key) =>{
    console.log('scrolling text onhover test')
  }
 const checkIfGroup=(chat)=>{
        return chat.isGroupChat
    }

    
const GroupChats = () => {
    const { selectedChat, setSelectedChat, user, chats, setChats } = ChatState();
   const [loggedUser, setLoggedUser] = useState();
   console.log('GroupChats:',chats)
    let g_chats = chats.filter(checkIfGroup)
    useEffect(()=>{

   },[g_chats])
   
  return (
//    <div className='scrollBox'>
        <Box
        // display="flex"
        // flexDir="column"
        // w="100%"
        h="100%"
        overflow={"scroll"}
        borderRadius="0px 10px 10px 10px"
       
      >
    {g_chats?.map((chat) => (

            <Box
              // display={(chat.chatName ===' ')?'flex':'none'}
              //  background={"bgs.chtBtn"}
              background ={'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6033950617283951) 18%, rgba(255,255,255,0.7160493827160495) 35%, rgba(223,252,255,0.8) 100%, rgba(254,255,255,0.9126436781609195) 100%)'}
              onClick={() => setSelectedChat(chat)}
              onTouchStart={()=>toggleScroll(chat._id)}
              cursor="pointer"
              // bg={selectedChat === chat ? "bgs.chtBtnSel" : "bgs.chtBtn"}
              color={selectedChat === chat ? "txt.chtBtnTxt" : "txt.chtBtnTxt"}
              border={selectedChat === chat ? "brd.chtBtnAct" : "brd.chtBtn"}
              borderLeft ={selectedChat === chat ? "brd.chtBtnActL" : "brd.chtBtn"}
              _hover={{
                // fontFamily:'Gilroy Bold ',
                background: "bgs.chtBtnSel",
                color: "txt.chtBtnTxtSel",
                border:"brd.chtBtnAct",
                borderRight: "none",
                // borderLeft: "none",
                borderBottom: "none",
              }}
              px={1}
              py={1}
              h={"63px"}
              minH={"63px"}
              // borderRadius="lg"
              borderRadius="0 5px 0 15px"
              // borderLeft={"none"}
              borderRight={"none"}
              borderBottom={"none"}
              className="chatNameCard"
              key={chat._id}
              boxShadow={"bxshd.chtBtn"}
              overflowX={'scroll'}
              overflowY={'hidden'}
              backdropFilter={"blur(4px)"}
              >

                <Text
                  whiteSpace={'nowrap'}
                >
                  {!chat?.isGroupChat
                    ? getSender(loggedUser, chat?.users)
                    : chat?.chatName}
                </Text>
                <Divider/>
                {chat.latestMessage && (
                  <div 
                    className="crt-mt-comp-info  display" 
                    id="scroll-container">
                    <div id="scroll-text">
                          
                      <Text fontSize="xs" whiteSpace={'nowrap'}>
                        <b>{chat.latestMessage.sender.preferredName} : </b>
                        {chat.latestMessage.content.length > 50
                          ? chat.latestMessage.content.substring(0, 51) + "..."
                          : chat.latestMessage.content}
                      </Text>
                       </div>
                    </div>
                )}
              </Box>
            ))} 
         {/* ) : (
         <ChatLoading />  */}
   {/* </div> */}
   </Box>
    // <Box
    //     display="flex"
    //     flexDir="column"
    //     p={3}
    //     // bg="rgba(250,250,250,0.2)"  
    //     bg="rgba(250,250,250,0.9)"  
    //     backgroundImage={"url('./assets/BodyBG2.png')"}
    //     // bg="#F8F8F8"  
    //     w="100%"
    //     h="100%"
    //     borderRadius="0px 10px 10px 10px"
    //     overflowY="hidden"
    //     // backgroundImage={"url('./assets/BodyBG.png')"}
    //     // backgroundColor={"bgs.accntBx"}
    //     boxShadow={"bxshd.inset_blk"}
    //      backdropFilter={"blur(2px)"} 
    //   >
          /* {g_chats?.map((chat) => (

            <Box
              // display={(chat.chatName ===' ')?'flex':'none'}
              //  background={"bgs.chtBtn"}
              background ={'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6033950617283951) 18%, rgba(255,255,255,0.7160493827160495) 35%, rgba(223,252,255,0.8) 100%, rgba(254,255,255,0.9126436781609195) 100%)'}
              onClick={() => setSelectedChat(chat)}
              onTouchStart={()=>toggleScroll(chat._id)}
              cursor="pointer"
              // bg={selectedChat === chat ? "bgs.chtBtnSel" : "bgs.chtBtn"}
              color={selectedChat === chat ? "txt.chtBtnTxt" : "txt.chtBtnTxt"}
              border={selectedChat === chat ? "brd.chtBtnAct" : "brd.chtBtn"}
              borderLeft ={selectedChat === chat ? "brd.chtBtnActL" : "brd.chtBtn"}
              _hover={{
                // fontFamily:'Gilroy Bold ',
                background: "bgs.chtBtnSel",
                color: "txt.chtBtnTxtSel",
                border:"brd.chtBtnAct",
                borderRight: "none",
                // borderLeft: "none",
                borderBottom: "none",
              }}
              px={1}
              py={1}
              minH={"63px"}
              // borderRadius="lg"
              borderRadius="0 5px 0 15px"
              // borderLeft={"none"}
              borderRight={"none"}
              borderBottom={"none"}
              className="chatNameCard"
              key={chat._id}
              boxShadow={"bxshd.chtBtn"}
              overflowX={'scroll'}
              overflowY={'hidden'}
              backdropFilter={"blur(4px)"}
              >

                <Text
                  whiteSpace={'nowrap'}
                >
                  {!chat?.isGroupChat
                    ? getSender(loggedUser, chat?.users)
                    : chat?.chatName}
                </Text>
                <Divider/>
                {chat.latestMessage && (
                  <div 
                    className="crt-mt-comp-info  display" 
                    id="scroll-container">
                    <div id="scroll-text">
                          
                      <Text fontSize="xs" whiteSpace={'nowrap'}>
                        <b>{chat.latestMessage.sender.preferredName} : </b>
                        {chat.latestMessage.content.length > 50
                          ? chat.latestMessage.content.substring(0, 51) + "..."
                          : chat.latestMessage.content}
                      </Text>
                       </div>
                    </div>
                )}
              </Box>
            ))} */
            //  ) : (
        //   <ChatLoading /> 
    //   </Box>
    
  )
}

export default GroupChats